// assets/a24-blog-inline-ads.js
/* Article-specific inline product recommendations. */
(function () {
  'use strict';

  /* ---- Blog article: inline shop ads – contextual per H2 ---- */
  function runBlogInlineAds(root) {
    var adsDebug = false;
    try {
      var dbgParam = new URLSearchParams(window.location.search).get('ads_debug');
      var dbgStorage = window.localStorage && window.localStorage.getItem('A24_ADS_DEBUG');
      adsDebug = dbgParam === '1' ||
        dbgStorage === '1' ||
        !!(window.Shopify && Shopify.designMode) ||
        (window.location && window.location.pathname && window.location.pathname.indexOf('/blogs/') !== -1);
    } catch (_) {
      adsDebug = !!(window.Shopify && Shopify.designMode);
    }

    function adsLog(level, message, payload) {
      if (!adsDebug) return;
      var logger = console[level] || console.log;
      if (typeof payload === 'undefined') logger.call(console, '[A24 BlogAds] ' + message);
      else logger.call(console, '[A24 BlogAds] ' + message, payload);
    }

    var scope = (root && typeof root.querySelector === 'function') ? root : document;
    var articleContent = scope.querySelector('.js-article-content') ||
      scope.querySelector('#blogContent') ||
      scope.querySelector('.blog-single .blog-content') ||
      scope.querySelector('.content-page .blog-content') ||
      scope.querySelector('main .blog-content');
    if (!articleContent) {
      adsLog('warn', 'Kein Artikel-Container gefunden', {
        scopeNode: scope === document ? 'document' : (scope.nodeName || 'unknown')
      });
      return;
    }

    adsLog('info', 'Start runBlogInlineAds', {
      path: window.location.pathname,
      scopeNode: scope === document ? 'document' : (scope.nodeName || 'unknown')
    });

    function isTrustedIframeSrc(src) {
      if (!src) return false;
      try {
        var url = new URL(src, window.location.origin);
        var host = (url.hostname || '').toLowerCase();
        if (url.protocol !== 'https:') return false;

        return host === 'www.youtube.com' ||
          host === 'youtube.com' ||
          host === 'youtu.be' ||
          host === 'www.youtube-nocookie.com' ||
          host === 'youtube-nocookie.com' ||
          host === 'player.vimeo.com' ||
          host === 'www.google.com' ||
          host === 'maps.google.com';
      } catch (_) {
        return false;
      }
    }

    function sanitizeBlogContent(container) {
      // Remove active/structural tags that can break page/editor layout.
      container.querySelectorAll(
        'script, style, object, embed, applet, form, meta, base, link[rel="stylesheet"]'
      ).forEach(function (node) {
        node.remove();
      });

      container.querySelectorAll('*').forEach(function (el) {
        var attrs = Array.prototype.slice.call(el.attributes || []);
        attrs.forEach(function (attr) {
          var name = String(attr.name || '').toLowerCase();
          var value = String(attr.value || '').trim();

          if (name.indexOf('on') === 0) {
            el.removeAttribute(attr.name);
            return;
          }

          if (name === 'srcdoc') {
            el.removeAttribute(attr.name);
            return;
          }

          if ((name === 'href' || name === 'src' || name === 'xlink:href') && /^javascript:/i.test(value)) {
            if (name === 'href') el.setAttribute('href', '#');
            else el.removeAttribute(attr.name);
            return;
          }

          if (name === 'style' && /(position\s*:\s*(fixed|absolute)|z-index\s*:\s*[0-9]{3,}|vw\s*;|vh\s*;)/i.test(value)) {
            el.removeAttribute('style');
          }
        });

        if (el.tagName === 'IFRAME') {
          var src = el.getAttribute('src') || '';
          if (!isTrustedIframeSrc(src)) {
            el.remove();
          }
        }
      });
    }

    sanitizeBlogContent(articleContent);

    /* Prevent double-run */
    if (articleContent.getAttribute('data-ads-enhanced') === '1') {
      adsLog('info', 'Abbruch: data-ads-enhanced bereits gesetzt');
      return;
    }
    articleContent.setAttribute('data-ads-enhanced', '1');

    var h2s = Array.prototype.slice.call(articleContent.querySelectorAll('h2'));
    if (h2s.length < 2) {
      adsLog('warn', 'Abbruch: zu wenige H2-Überschriften für Inline-Ads', { h2Count: h2s.length });
      return;
    }

    var adsMode = (articleContent.getAttribute('data-ads-mode') || 'blog_assigned_then_auto').trim();
    var adsPerBlock = parseInt(articleContent.getAttribute('data-ads-per-block') || '3', 10);
    if (isNaN(adsPerBlock)) adsPerBlock = 3;
    adsPerBlock = Math.max(2, Math.min(4, adsPerBlock));

    var articleQuery = (articleContent.getAttribute('data-article-query') || '').trim();
    adsLog('info', 'Grunddaten geladen', {
      adsMode: adsMode,
      adsPerBlock: adsPerBlock,
      articleQuery: articleQuery,
      h2Count: h2s.length
    });

    /* ---- Helper functions ---- */
    function esc(str) {
      return String(str || '')
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function toEuro(cents) {
      return (Number(cents || 0) / 100).toFixed(2).replace('.', ',') + ' \u20ac';
    }

    function truncate(text, max) {
      if (!text) return '';
      return text.length <= max ? text : text.slice(0, max - 3) + '...';
    }

    function normalizeImageUrl(raw) {
      if (!raw) return '';
      var url = String(raw).trim();
      if (!url) return '';
      if (url.indexOf('//') === 0) return 'https:' + url;
      return url;
    }

    function normalizeProducts(list) {
      var unique = [], seen = {};
      (list || []).forEach(function (p) {
        if (!p) return;
        var url = p.url || (p.handle ? '/products/' + p.handle : '');
        if (!url || seen[url]) return;
        seen[url] = true;
        var img = normalizeImageUrl(
          p.featured_image && (p.featured_image.url || p.featured_image.src) ||
          p.image && (p.image.url || p.image.src) ||
          p.images && p.images[0] && (p.images[0].url || p.images[0].src || p.images[0]) || ''
        );
        unique.push({
          url: url, title: p.title || '', vendor: p.vendor || '',
          price: p.price || 0,
          compare_at_price: p.compare_at_price || p.compare_at_price_max || 0,
          featured_image: img ? { url: img } : null
        });
      });
      return unique;
    }

    function productCardHTML(p) {
      var imageUrl = normalizeImageUrl(p.featured_image && (p.featured_image.url || p.featured_image.src) || '');
      var price = p.price ? '<strong>' + toEuro(p.price) + '</strong>' : '';
      var oldPrice = (p.compare_at_price && p.compare_at_price > p.price)
        ? '<s class="blog-product-card__price--old">' + toEuro(p.compare_at_price) + '</s>' : '';
      var discountPercent = (p.compare_at_price && p.compare_at_price > p.price)
        ? Math.round(((p.compare_at_price - p.price) * 100) / p.compare_at_price)
        : 0;
      var saleBadge = (p.compare_at_price && p.compare_at_price > p.price)
        ? '<span class="blog-product-card__badge">-' + String(discountPercent) + '%</span>' : '';
      var imageHtml = imageUrl
        ? '<img src="' + esc(imageUrl) + '" alt="' + esc(p.title || '') + '" loading="lazy">'
        : '<svg viewBox="0 0 24 24" width="80" height="80" fill="currentColor" style="opacity:.25"><path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/></svg>';
      return '<a href="' + esc(p.url || '#') + '" class="blog-product-card">' +
        saleBadge +
        '<div class="blog-product-card__img">' + imageHtml + '</div>' +
        '<span class="blog-product-card__brand">' + esc(p.vendor || '') + '</span>' +
        '<h4 class="blog-product-card__title">' + esc(truncate(p.title || '', 68)) + '</h4>' +
        '<div class="blog-product-card__price">' + oldPrice + price + '</div>' +
        '<span class="blog-product-card__cta">Zum Produkt</span>' +
        '</a>';
    }

    function updateBlock(block, products) {
      var grid = block.querySelector('.blog-products__grid');
      if (!grid) return;
      var set = products.slice(0, adsPerBlock);
      grid.innerHTML = set.map(productCardHTML).join('');
      block.setAttribute('data-inline-shop-ads', 'true');
    }

    /* ---- Manual mapping: source cards from blog/article/collection scopes ---- */
    var sourceCards = Array.prototype.slice.call(
      document.querySelectorAll('.js-blog-ads-source .blog-product-card[data-source="blog-scope-mapping"]')
    );
    var adsSourceRoot = document.querySelector('.js-blog-ads-source');
    var mapCandidates = Array.prototype.slice.call(
      document.querySelectorAll('.js-blog-ads-source .js-blog-map-candidate')
    );
    var mapHits = Array.prototype.slice.call(
      document.querySelectorAll('.js-blog-ads-source .js-blog-map-hit')
    );
    adsLog('info', 'Mapping-Karten gefunden', {
      sourceCards: sourceCards.length,
      currentBlogHandle: adsSourceRoot ? (adsSourceRoot.getAttribute('data-current-blog-handle') || '') : '',
      currentArticleHandle: adsSourceRoot ? (adsSourceRoot.getAttribute('data-current-article-handle') || '') : '',
      mapCandidates: mapCandidates.map(function (el) {
        return {
          match: el.getAttribute('data-map-match') || '',
          targetBlog: el.getAttribute('data-target-blog') || '',
          targetType: el.getAttribute('data-target-type') || '',
          sourceMode: el.getAttribute('data-source-mode') || '',
          targetArticles: el.getAttribute('data-target-articles') || '',
          targetCollections: el.getAttribute('data-target-collections') || '',
          currentBlog: el.getAttribute('data-current-blog') || '',
          currentArticle: el.getAttribute('data-current-article') || ''
        };
      }),
      mapHits: mapHits.map(function (el) {
        return {
          sourceMode: el.getAttribute('data-source-mode') || '',
          productsAdded: el.getAttribute('data-products-added') || '0',
          metaNamespace: el.getAttribute('data-meta-namespace') || '',
          metaKey: el.getAttribute('data-meta-key') || ''
        };
      }),
      sample: sourceCards.slice(0, 6).map(function (card) {
        var titleEl = card.querySelector('.blog-product-card__title');
        return {
          href: card.getAttribute('href') || '',
          title: titleEl ? titleEl.textContent.trim() : '',
          targetType: card.getAttribute('data-target-type') || '',
          sourceMode: card.getAttribute('data-source-mode') || ''
        };
      })
    });

    if (sourceCards.length && adsMode !== 'auto_only') {
      var serverBlocks = Array.prototype.slice.call(
        articleContent.querySelectorAll('[data-inline-shop-ads="server"]')
      );
      adsLog('info', 'Nutze Mapping-Karten für Inline-Blocks', {
        serverBlocks: serverBlocks.length,
        sourceCards: sourceCards.length
      });
      var si = 0;
      serverBlocks.forEach(function (block) {
        var grid = block.querySelector('.blog-products__grid');
        if (!grid) return;
        grid.innerHTML = '';
        for (var i = 0; i < adsPerBlock; i++) {
          grid.appendChild(sourceCards[(si + i) % sourceCards.length].cloneNode(true));
        }
        block.setAttribute('data-inline-shop-ads', 'true');
        si = (si + adsPerBlock) % sourceCards.length;
      });
      return;
    }

    if (!sourceCards.length && adsMode === 'blog_assigned_only') {
      var configuredMapCount = document.querySelectorAll('.js-blog-ads-source .js-blog-map-config').length;
      adsLog('info', 'Kein Mapping-Treffer im blog_assigned_only', {
        configuredMapCount: configuredMapCount
      });
      if (configuredMapCount > 0) {
        /* Mapping exists but no hit for this article/blog: avoid showing generic all-products fallback. */
        Array.prototype.slice.call(
          articleContent.querySelectorAll('[data-inline-shop-ads="server"]')
        ).forEach(function (block) {
          block.remove();
        });
        adsLog('warn', 'Mappings existieren, aber ohne Treffer: server fallback entfernt');
        return;
      }

      /* No mapping configured at all:
         keep server-rendered fallback cards visible. */
      adsLog('info', 'Keine Mapping-Blöcke konfiguriert: server fallback bleibt aktiv');
      return;
    }

    /* ---- Contextual mode: suggest.json per H2 ---- */
    var suggestCache = {};

    function fetchSuggest(q) {
      if (!q || q.length < 3) return Promise.resolve([]);
      if (suggestCache[q] !== undefined) return Promise.resolve(suggestCache[q]);
      return fetch(
        '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=8',
        { headers: { 'X-Requested-With': 'XMLHttpRequest' } }
      )
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var prods = normalizeProducts(
          data && data.resources && data.resources.results && data.resources.results.products || []
        );
        suggestCache[q] = prods;
        return prods;
      })
      .catch(function () { suggestCache[q] = []; return []; });
    }

    function mergeWithFallback(contextual, fallback) {
      /* Supplement contextual results with fallback products (deduped) */
      var seen = {};
      var result = contextual.slice();
      result.forEach(function (p) { seen[p.url] = true; });
      fallback.forEach(function (p) {
        if (result.length >= adsPerBlock) return;
        if (!seen[p.url]) { seen[p.url] = true; result.push(p); }
      });
      return result;
    }

    /* serverBlocks[i] sits before h2[i+2] in the DOM; each block carries
       its H2 text in data-h2-query for direct contextual lookup. */
    var serverBlocks = Array.prototype.slice.call(
      articleContent.querySelectorAll('[data-inline-shop-ads="server"]')
    );

    /* Fetch all-products fallback once, then enhance each block */
    fetch('/products.json?limit=48', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var fallback = normalizeProducts(data && data.products || []);
        adsLog('info', 'Contextual-Fallback geladen', { fallbackCount: fallback.length });

        /* articleQuery always contains title (+tags); extract first token group
           (typically brand/product name) as a tighter fallback query */
        var articleTitleQuery = articleQuery.split(/\s+/).slice(0, 3).join(' ');

        serverBlocks.forEach(function (block, idx) {
          var h2Query = (block.getAttribute('data-h2-query') || '').trim();
          /* q1: full h2 + article context; q2: article-only; q3: short title snippet */
          var q1 = [h2Query, articleQuery].filter(Boolean).join(' ').trim();
          var q2 = articleQuery || h2Query;
          var q3 = articleTitleQuery;

          /* Fallback slice: each block gets a different offset so they're not all identical */
          var fallbackSlice = fallback.slice(idx * adsPerBlock % Math.max(fallback.length, 1));
          if (fallbackSlice.length < adsPerBlock) fallbackSlice = fallback;

          fetchSuggest(q1).then(function (prods) {
            if (prods.length >= adsPerBlock) {
              adsLog('info', 'Block über q1 befüllt', { idx: idx, q1Count: prods.length, q1: q1 });
              updateBlock(block, prods);
            } else {
              return fetchSuggest(q2).then(function (prods2) {
                var best = prods2.length >= adsPerBlock ? prods2 :
                           (prods2.length > prods.length ? prods2 : prods);
                if (best.length >= adsPerBlock) {
                  adsLog('info', 'Block über q2/best befüllt', {
                    idx: idx,
                    q1Count: prods.length,
                    q2Count: prods2.length,
                    bestCount: best.length,
                    q2: q2
                  });
                  updateBlock(block, best);
                } else {
                  /* Last resort: try short title query before random fallback */
                  return fetchSuggest(q3).then(function (prods3) {
                    var base = [prods3, best].sort(function (a, b) { return b.length - a.length; })[0];
                    var combined = mergeWithFallback(base, fallbackSlice);
                    if (combined.length) {
                      adsLog('info', 'Block über q3+fallback befüllt', {
                        idx: idx,
                        q1Count: prods.length,
                        q2Count: prods2.length,
                        q3Count: prods3.length,
                        combinedCount: combined.length,
                        q3: q3
                      });
                      updateBlock(block, combined);
                    }
                  });
                }
              });
            }
          });
        });
      })
      .catch(function (err) {
        adsLog('error', 'Contextual-Fallback fehlgeschlagen', {
          error: (err && err.message) ? err.message : String(err)
        });
      });
  }

  try {
    runBlogInlineAds(document);
  } catch (err) {
    console.error('[A24 BlogAds] runBlogInlineAds(document) failed', err);
  }

  ['shopify:section:load', 'shopify:section:select', 'shopify:block:select'].forEach(function (evtName) {
    document.addEventListener(evtName, function (event) {
      if (!(window.Shopify && Shopify.designMode)) return;
      console.info('[A24 BlogAds] Editor event', evtName);
      try {
        runBlogInlineAds(event && event.target ? event.target : document);
      } catch (err) {
        console.error('[A24 BlogAds] runBlogInlineAds(editor-event) failed', {
          eventName: evtName,
          error: err && err.message ? err.message : String(err)
        });
      }
    });
  });
}());
